<template>
    <div class="upcoming-events-fullcalendar">
      {{ move }}
      <FullCalendar
      :options="calendarOptions"
      ref="fullCalendar"
      />
    </div>
</template>
<script>

import FullCalendar from '@fullcalendar/vue3'
import DayGridPlugin from '@fullcalendar/daygrid'
import TimeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import ListPlugin from '@fullcalendar/interaction'
import { useEventsStore } from '@/store/events'

export default {
    name: 'UpcomingEventsFullCalendar',
    components: {
        FullCalendar
    },
  computed:{
    events(){
      const eventsStore = useEventsStore()
      let return_events = []
      for (let event of eventsStore.eventsFilters){
        let title = event.name
        if (title === null)
            title = ''
        return_events.push({
          'title': title,
          'date': event.date_start
        })
      }
      return return_events
    },
    selectedDate(){
      return useEventsStore().selectedDate
    },
    calendarOptions(){
      return {
        plugins: [ DayGridPlugin, interactionPlugin, TimeGridPlugin, DayGridPlugin, ListPlugin ],
        initialView: 'timeGridWeek',
        headerToolbar: false,
        allDaySlot: false,
        firstDay: 1,
        height: 748,
        width: 400,
        'events': this.events
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let monday_th = document.querySelector('.fc-day-mon');
      let monday_a = monday_th.childNodes[0].childNodes[0]
      let monday_day = monday_a.textContent.substring(monday_a.textContent.indexOf('/')+1,monday_a.textContent.length)
      monday_a.textContent = monday_day + ' ПН'
      let tuesday_th = document.querySelector('.fc-day-tue');
      let tuesday_a = tuesday_th.childNodes[0].childNodes[0]
      let tuesday_day = tuesday_a.textContent.substring(tuesday_a.textContent.indexOf('/')+1,tuesday_a.textContent.length)
      tuesday_a.textContent = tuesday_day + ' ВТ'
      let wednesday_th = document.querySelector('.fc-day-wed');
      let wednesday_a = wednesday_th.childNodes[0].childNodes[0]
      let wednesday_day = wednesday_a.textContent.substring(wednesday_a.textContent.indexOf('/')+1,wednesday_a.textContent.length)
      wednesday_a.textContent = wednesday_day + ' СР'
      let thursday_th = document.querySelector('.fc-day-thu');
      let thursday_a = thursday_th.childNodes[0].childNodes[0]
      let thursday_day = thursday_a.textContent.substring(thursday_a.textContent.indexOf('/')+1,thursday_a.textContent.length)
      thursday_a.textContent = thursday_day + ' ЧТ'
      let friday_th = document.querySelector('.fc-day-fri');
      let friday_a = friday_th.childNodes[0].childNodes[0]
      let friday_day = friday_a.textContent.substring(friday_a.textContent.indexOf('/')+1,friday_a.textContent.length)
      friday_a.textContent = friday_day + ' ПТ'
      let saturday_th = document.querySelector('.fc-day-sat');
      let saturday_a = saturday_th.childNodes[0].childNodes[0]
      let saturday_day = saturday_a.textContent.substring(saturday_a.textContent.indexOf('/')+1,saturday_a.textContent.length)
      saturday_a.textContent = saturday_day + ' СБ'
      let sunday_th = document.querySelector('.fc-day-sun');
      let sunday_a = sunday_th.childNodes[0].childNodes[0]
      let sunday_day = sunday_a.textContent.substring(sunday_a.textContent.indexOf('/')+1,sunday_a.textContent.length)
      sunday_a.textContent = sunday_day + ' ВС'

      let time_columns = document.querySelectorAll('.fc-timegrid-slot-label-cushion');
      let new_time_column = {
        '12am': '00:00',
        '1am': '01:00',
        '2am': '02:00',
        '3am': '03:00',
        '4am': '04:00',
        '5am': '05:00',
        '6am': '06:00',
        '7am': '07:00',
        '8am': '08:00',
        '9am': '09:00',
        '10am': '10:00',
        '11am': '11:00',
        '12pm': '12:00',
        '1pm': '13:00',
        '2pm': '14:00',
        '3pm': '15:00',
        '4pm': '16:00',
        '5pm': '17:00',
        '6pm': '18:00',
        '7pm': '19:00',
        '8pm': '20:00',
        '9pm': '21:00',
        '10pm': '22:00',
        '11pm': '23:00'}
      for (let column_label of time_columns){
        column_label.textContent = new_time_column[column_label.textContent]
      }
      this.emitWeek(this.$refs.fullCalendar.getApi().view.getCurrentData().dateProfile.activeRange.start,
      this.$refs.fullCalendar.getApi().view.getCurrentData().dateProfile.activeRange.end
      )
    })
  },
  props: {
    move: String
  },
  methods: {
    emitWeek(start, end){
      this.$emit('changeWeekDate',start, end)
    },
  },
  watch: {
    selectedDate(newDate){
      // this.$refs.fullCalendar.gotoDate(newDate)
      console.log('this.$refs.fullCalendar')
      console.log(this.$refs.fullCalendar.calendar.gotoDate(newDate))
      this.$nextTick(() => {
      let monday_th = document.querySelector('.fc-day-mon');
      let monday_a = monday_th.childNodes[0].childNodes[0]
      let monday_day = monday_a.textContent.substring(monday_a.textContent.indexOf('/')+1,monday_a.textContent.length)
      monday_a.textContent = monday_day + ' ПН'
      let tuesday_th = document.querySelector('.fc-day-tue');
      let tuesday_a = tuesday_th.childNodes[0].childNodes[0]
      let tuesday_day = tuesday_a.textContent.substring(tuesday_a.textContent.indexOf('/')+1,tuesday_a.textContent.length)
      tuesday_a.textContent = tuesday_day + ' ВТ'
      let wednesday_th = document.querySelector('.fc-day-wed');
      let wednesday_a = wednesday_th.childNodes[0].childNodes[0]
      let wednesday_day = wednesday_a.textContent.substring(wednesday_a.textContent.indexOf('/')+1,wednesday_a.textContent.length)
      wednesday_a.textContent = wednesday_day + ' СР'
      let thursday_th = document.querySelector('.fc-day-thu');
      let thursday_a = thursday_th.childNodes[0].childNodes[0]
      let thursday_day = thursday_a.textContent.substring(thursday_a.textContent.indexOf('/')+1,thursday_a.textContent.length)
      thursday_a.textContent = thursday_day + ' ЧТ'
      let friday_th = document.querySelector('.fc-day-fri');
      let friday_a = friday_th.childNodes[0].childNodes[0]
      let friday_day = friday_a.textContent.substring(friday_a.textContent.indexOf('/')+1,friday_a.textContent.length)
      friday_a.textContent = friday_day + ' ПТ'
      let saturday_th = document.querySelector('.fc-day-sat');
      let saturday_a = saturday_th.childNodes[0].childNodes[0]
      let saturday_day = saturday_a.textContent.substring(saturday_a.textContent.indexOf('/')+1,saturday_a.textContent.length)
      saturday_a.textContent = saturday_day + ' СБ'
      let sunday_th = document.querySelector('.fc-day-sun');
      let sunday_a = sunday_th.childNodes[0].childNodes[0]
      let sunday_day = sunday_a.textContent.substring(sunday_a.textContent.indexOf('/')+1,sunday_a.textContent.length)
      sunday_a.textContent = sunday_day + ' ВС'})
    },
    move(oldValue,newValue){
      if (newValue == 'left'){
        console.log('left')
      }
      if (newValue == 'right'){
        console.log('right')
      }
      if (newValue != '')
        this.$emit('endMove')
    }
  }
}
</script>